<template>
  <span :class="['client-logo', className]">
    <SkeletonImage v-if="hasLogo" :src="logoSrc" :alt="logoAlt" className="client-logo-img" />
    <span v-else class="client-logo-fallback">{{ logoAlt }}</span>
  </span>
</template>

<script lang="ts" src="./client-logo.component.ts"></script>
<style scoped lang="scss" src="./client-logo.scss"></style>
